/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * train-with-me
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetPublicFormsLeadsParams,
  MicrosoftAspNetCoreMvcProblemDetails,
  TrainWithMeModulesClientsDtosResponsesGetCustomerResponse,
  TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest,
  TrainWithMeModulesPublicFormsDtosResponsesPublicFormLeadDetailResponse,
  TrainWithMeModulesPublicFormsDtosResponsesPublicFormLeadPageResponse
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getPublicFormsLeads = (
    params?: GetPublicFormsLeadsParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormLeadPageResponse>(
      {url: `/public-forms/leads`, method: 'GET',
        params, signal
    },
      options);
    }




export const getGetPublicFormsLeadsQueryKey = (params?: GetPublicFormsLeadsParams,) => {
    return [
    `/public-forms/leads`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPublicFormsLeadsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicFormsLeads>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(params?: GetPublicFormsLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicFormsLeadsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicFormsLeads>>> = ({ signal }) => getPublicFormsLeads(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeads>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicFormsLeadsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicFormsLeads>>>
export type GetPublicFormsLeadsQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetPublicFormsLeads<TData = Awaited<ReturnType<typeof getPublicFormsLeads>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params: undefined |  GetPublicFormsLeadsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeads>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsLeads>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsLeads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsLeads<TData = Awaited<ReturnType<typeof getPublicFormsLeads>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetPublicFormsLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeads>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsLeads>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsLeads>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsLeads<TData = Awaited<ReturnType<typeof getPublicFormsLeads>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetPublicFormsLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicFormsLeads<TData = Awaited<ReturnType<typeof getPublicFormsLeads>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 params?: GetPublicFormsLeadsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeads>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicFormsLeadsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const deletePublicFormsLeadsLeadId = (
    leadId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/public-forms/leads/${leadId}`, method: 'DELETE', signal
    },
      options);
    }




export const getDeletePublicFormsLeadsLeadIdMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicFormsLeadsLeadId>>, TError,{leadId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deletePublicFormsLeadsLeadId>>, TError,{leadId: number}, TContext> => {

const mutationKey = ['deletePublicFormsLeadsLeadId'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deletePublicFormsLeadsLeadId>>, {leadId: number}> = (props) => {
          const {leadId} = props ?? {};

          return  deletePublicFormsLeadsLeadId(leadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeletePublicFormsLeadsLeadIdMutationResult = NonNullable<Awaited<ReturnType<typeof deletePublicFormsLeadsLeadId>>>

    export type DeletePublicFormsLeadsLeadIdMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const useDeletePublicFormsLeadsLeadId = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deletePublicFormsLeadsLeadId>>, TError,{leadId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deletePublicFormsLeadsLeadId>>,
        TError,
        {leadId: number},
        TContext
      > => {
      return useMutation(getDeletePublicFormsLeadsLeadIdMutationOptions(options), queryClient);
    }
    export const getPublicFormsLeadsLeadId = (
    leadId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesPublicFormsDtosResponsesPublicFormLeadDetailResponse>(
      {url: `/public-forms/leads/${leadId}`, method: 'GET', signal
    },
      options);
    }




export const getGetPublicFormsLeadsLeadIdQueryKey = (leadId: number,) => {
    return [
    `/public-forms/leads/${leadId}`
    ] as const;
    }


export const getGetPublicFormsLeadsLeadIdQueryOptions = <TData = Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(leadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicFormsLeadsLeadIdQueryKey(leadId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>> = ({ signal }) => getPublicFormsLeadsLeadId(leadId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: leadId !== null && leadId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPublicFormsLeadsLeadIdQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>>
export type GetPublicFormsLeadsLeadIdQueryError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>


export function useGetPublicFormsLeadsLeadId<TData = Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 leadId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsLeadsLeadId<TData = Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 leadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>,
          TError,
          Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPublicFormsLeadsLeadId<TData = Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 leadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPublicFormsLeadsLeadId<TData = Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>>(
 leadId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPublicFormsLeadsLeadId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPublicFormsLeadsLeadIdQueryOptions(leadId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const postPublicFormsLeadsLeadIdConvert = (
    leadId: number,
    trainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest>,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<TrainWithMeModulesClientsDtosResponsesGetCustomerResponse>(
      {url: `/public-forms/leads/${leadId}/convert`, method: 'POST',
      headers: {'Content-Type': 'application/*+json', },
      data: trainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest, signal
    },
      options);
    }




export const getPostPublicFormsLeadsLeadIdConvertMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdConvert>>, TError,{leadId: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdConvert>>, TError,{leadId: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest>}, TContext> => {

const mutationKey = ['postPublicFormsLeadsLeadIdConvert'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdConvert>>, {leadId: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest>}> = (props) => {
          const {leadId,data} = props ?? {};

          return  postPublicFormsLeadsLeadIdConvert(leadId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPublicFormsLeadsLeadIdConvertMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdConvert>>>
    export type PostPublicFormsLeadsLeadIdConvertMutationBody = BodyType<TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest> | undefined
    export type PostPublicFormsLeadsLeadIdConvertMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostPublicFormsLeadsLeadIdConvert = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdConvert>>, TError,{leadId: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdConvert>>,
        TError,
        {leadId: number;data?: BodyType<TrainWithMeModulesPublicFormsDtosRequestsConvertPublicFormLeadRequest>},
        TContext
      > => {
      return useMutation(getPostPublicFormsLeadsLeadIdConvertMutationOptions(options), queryClient);
    }
    export const postPublicFormsLeadsLeadIdViewed = (
    leadId: number,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {


      return customInstance<void>(
      {url: `/public-forms/leads/${leadId}/viewed`, method: 'POST', signal
    },
      options);
    }




export const getPostPublicFormsLeadsLeadIdViewedMutationOptions = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdViewed>>, TError,{leadId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdViewed>>, TError,{leadId: number}, TContext> => {

const mutationKey = ['postPublicFormsLeadsLeadIdViewed'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdViewed>>, {leadId: number}> = (props) => {
          const {leadId} = props ?? {};

          return  postPublicFormsLeadsLeadIdViewed(leadId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type PostPublicFormsLeadsLeadIdViewedMutationResult = NonNullable<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdViewed>>>

    export type PostPublicFormsLeadsLeadIdViewedMutationError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>

    export const usePostPublicFormsLeadsLeadIdViewed = <TError = ErrorType<MicrosoftAspNetCoreMvcProblemDetails>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdViewed>>, TError,{leadId: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof postPublicFormsLeadsLeadIdViewed>>,
        TError,
        {leadId: number},
        TContext
      > => {
      return useMutation(getPostPublicFormsLeadsLeadIdViewedMutationOptions(options), queryClient);
    }
